
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landing/carrot",
      function () {
        return require("private-next-pages/landing/carrot.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landing/carrot"])
      });
    }
  